import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";

const MemberData = () => {

    const [dataMember, setDataMember] = useState([]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert to 12-hour format

        return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
    };

    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    useEffect(() => {
        fetchData('https://signinapi.heuristticminds.com/api/Member/Get-GetMemberDetailsAll', setDataMember);

    }, [dataMember]);

    const columns = [
        {
            name: "Badge ID",
            selector: row => row.badgeID,
            width: "100px"
        },
        {
            name: "Full Name",
            selector: row => row.memberName,
            maxWidth: "250px",
        },
        {
            name: "Mobile",
            selector: row => row.mobile,
            maxWidth: "150px",
        },
        {
            name: "Email",
            selector: row => row.eMail,
            maxWidth: "250px",
        },
        // {
        //     name: "Firm Name",
        //     selector: row => row.firmName,
        //     maxWidth:"350px",
        // },
        {
            name: "SignIn Status",
            selector: row => row.signInStatus,
            cell: row => (
                <img
                    src={row.signInStatus === 1 ? "/images/tic.jpg" : "/images/imgDel.png"}
                    alt={row.signInStatus === 1 ? 'Signed In' : 'Not Signed In'}
                    style={{ width: "28px", height: "28px" }} // Adjust size as needed
                />
            ),
            maxWidth: "150px",
        },
        {
            name: "Date-Time",
            cell: (row) => <span>{formatDate(row.signInDate)}</span>,
            //selector: row => row.signInDate,
            maxWidth: "200px",
        },

    ];

    return (
        <>
            <header>
                <div className="logo1">
                    <img src="images/mumbai fc.jpg" alt="mumbai fc logo" />
                </div>
                <div className="logo2">
                    <img src="images/insol-india-logo.jpg" alt="insol india logo" />
                </div>
            </header>
            <div className="container">
                <div className="logintitle" style={{color:"#222222"}}>
                    Participant Data
                </div>
            </div>
            <div className="container">
                <DataTable
                    columns={columns}
                    data={dataMember}
                    pagination={10}
                />
            </div>
            
        </>
    )
};
export default MemberData;
